import firebase from 'firebase/app'

import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/functions';

firebase.initializeApp({
  apiKey: "AIzaSyD2Bf1pSpFM9XcXtrbYiWqYbQGYmHdoh0c",
  authDomain: "todo-33cf0.firebaseapp.com",
  projectId: "todo-33cf0",
  storageBucket: "todo-33cf0.appspot.com",
  messagingSenderId: "206228025921",
  appId: "1:206228025921:web:99b3caec2345acb2084cc0",
  measurementId: "G-0GH1NHTP4H"
});

export const functions = firebase.functions();
export const auth = firebase.auth();
export const firestore = firebase.firestore();
